<page-header
  [title]="(editMode ? 'Edit ' : 'New ') + 'Voucher'"
  [subtitle]="subtitle"
></page-header>

<form [formGroup]="form" *ngIf="!loading">
  <div class="row">
    <div style="display: flex; justify-content: flex-end; margin-bottom: 10px">
      <div style="display: flex; gap: 10px">
        <app-primary-button
          [title]="constants.strings.cancel"
          border="1px solid var(--app-container)"
          bgColor="transparent"
          color="white"
          (tapped)="back()"
        ></app-primary-button>

        <app-primary-button
          *ngIf="editMode"
          title="Actions"
          [disabled]="loading || saving || previewingPDF"
          border="1px solid var(--app-container)"
          bgColor="transparent"
          color="white"
          [matMenuTriggerFor]="actionsMenu"
          icon="arrow_drop_down"
        ></app-primary-button>

        <app-primary-button
          title="Save"
          [disabled]="loading || saving"
          border="1px solid var(--app-container)"
          (tapped)="save()"
        ></app-primary-button>
      </div>
    </div>
    <div class="col-xl-7">
      <div class="detail-container" id="left">
        <div class="form-field">
          <single-select
            label="Voucher type"
            [formCtrl]="voucherTypeFormControl"
            [options]="voucherTypeOptions"
            [property]="'label'"
            [inBrackets]="'info'"
            [value]="voucherTypeFormControl.value"
            [disabled]="editMode"
            (selected)="voucherTypeSelected()"
          >
          </single-select>
        </div>

        <div class="form-field" style="margin-top: 20px">
          <div class="form-field-label">
            Title<span style="color: red">*</span>
          </div>
          <input
            type="text"
            class="form-input"
            [formControl]="titleFormControl"
            placeholder="e.g. Special Gift voucher"
            [ngStyle]="{
              border:
                titleFormControl.invalid && submitted
                  ? '1px solid red'
                  : '1px solid var(--app-light-grey)',
            }"
          />
          <div
            *ngIf="
              valueFormControl.value &&
              titleFormControl.value &&
              voucherType === 'fixed'
            "
            class="form-field-label"
            style="
              font-style: italic;
              font-size: 14px;
              margin-top: 5px;
              color: grey;
            "
          >
            Displayed as: "<span *ngIf="showValueInDisplayControl.value"
              >£{{ valueFormControl.value | number: "1.0-2" }} </span
            >{{ titleFormControl.value }}"
          </div>
        </div>

        <div
          class="form-field"
          style="margin-top: 20px"
          *ngIf="voucherType === 'fixed' && (valueFormControl.value ?? 0) > 0"
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div class="form-field-label">Show value in display name</div>
            <mat-slide-toggle [formControl]="showValueInDisplayControl">
            </mat-slide-toggle>
          </div>
        </div>

        <div class="form-field" style="margin-top: 20px">
          <div class="form-field-label">
            Description<span style="color: red">*</span>
          </div>
          <textarea
            class="form-input"
            [formControl]="descriptionFormControl"
            placeholder="Enter voucher description"
            rows="3"
            [ngStyle]="{
              border:
                descriptionFormControl.invalid && submitted
                  ? '1px solid red'
                  : '1px solid var(--app-light-grey)',
            }"
          ></textarea>
        </div>

        <div *ngIf="voucherTypeFormControl.value">
          <div
            style="display: flex; gap: 20px; margin-top: 20px"
            *ngIf="voucherType === 'fixed'"
          >
            <div class="form-field" style="flex: 1">
              <div class="form-field-label">
                Redeemable value<span style="color: red">*</span
                ><span
                  ><info-icon
                    text="The amount the beneficiary can redeem from the voucher, this can be less than the cost"
                  ></info-icon>
                </span>
              </div>
              <input
                type="number"
                class="form-input"
                [formControl]="valueFormControl"
                placeholder="Enter redeemable value (£0 or greater)"
                [min]="0"
                [ngStyle]="{
                  border:
                    (valueFormControl.invalid ||
                      form.hasError('valueLessThanCost')) &&
                    submitted
                      ? '1px solid red'
                      : '1px solid var(--app-light-grey)',
                }"
              />
            </div>

            <div class="form-field" style="flex: 1">
              <div class="form-field-label">
                Cost to customer<span style="color: red">*</span>
              </div>
              <div style="display: flex; gap: 10px; align-items: center">
                <input
                  type="number"
                  class="form-input"
                  [formControl]="costFormControl"
                  [placeholder]="
                    'Enter purchase price (min ' + '£' + minimumCost + ')'
                  "
                  [min]="minimumCost"
                  [ngStyle]="{
                    border:
                      costFormControl.invalid && submitted
                        ? '1px solid red'
                        : '1px solid var(--app-light-grey)',
                  }"
                />
                <div
                  style="font-size: 12px; width: 80px"
                  *ngIf="getDiscountPercentage() > 0"
                >
                  <span>
                    {{ getDiscountPercentage() | number: "1.0-0" }}% OFF
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            style="display: flex; gap: 20px; margin-top: 20px"
            *ngIf="voucherType === 'monetary'"
          >
            <div class="form-field" style="flex: 1">
              <div class="form-field-label">
                Min Value<span style="color: red">*</span>
              </div>
              <input
                type="number"
                class="form-input"
                [formControl]="minFormControl"
                [placeholder]="'Enter min value (min ' + '£' + minValue + ')'"
                [min]="minValue"
                [ngStyle]="{
                  border:
                    minFormControl.invalid &&
                    (submitted || minFormControl.touched)
                      ? '1px solid red'
                      : '1px solid var(--app-light-grey)',
                }"
              />
              <div
                *ngIf="
                  minFormControl.invalid &&
                  (submitted || minFormControl.touched)
                "
                style="color: red; font-size: 12px; margin-top: 5px"
              >
                {{ getMinError() }}
              </div>
            </div>

            <div class="form-field" style="flex: 1">
              <div class="form-field-label">
                Max Value<span style="color: red">*</span>
              </div>
              <div style="display: flex; gap: 10px; align-items: center">
                <input
                  type="number"
                  class="form-input"
                  [formControl]="maxFormControl"
                  [placeholder]="'Enter max value'"
                  [min]="minFormControl.value"
                  [ngStyle]="{
                    border:
                      maxFormControl.invalid &&
                      (submitted || maxFormControl.touched)
                        ? '1px solid red'
                        : '1px solid var(--app-light-grey)',
                  }"
                />
              </div>
              <div
                *ngIf="
                  maxFormControl.invalid &&
                  (submitted || maxFormControl.touched)
                "
                style="color: red; font-size: 12px; margin-top: 5px"
              >
                {{ getMaxError() }}
              </div>
            </div>

            <div class="form-field" style="flex: 1">
              <div class="form-field-label">
                Increment<span style="color: red">*</span>
              </div>
              <div style="display: flex; gap: 10px; align-items: center">
                <input
                  type="number"
                  class="form-input"
                  [formControl]="incrementFormControl"
                  [placeholder]="'Enter increment'"
                  [ngStyle]="{
                    border:
                      incrementFormControl.invalid &&
                      (submitted || incrementFormControl.touched)
                        ? '1px solid red'
                        : '1px solid var(--app-light-grey)',
                  }"
                />
              </div>
              <div
                *ngIf="
                  incrementFormControl.invalid &&
                  (submitted || incrementFormControl.touched)
                "
                style="color: red; font-size: 12px; margin-top: 5px"
              >
                {{ getIncrementError() }}
              </div>
            </div>
          </div>

          <div class="form-field" style="margin-top: 20px">
            <div
              class="form-field"
              style="display: flex; justify-content: space-between"
            >
              <div class="form-field-label">Voucher has an expiry date</div>
              <mat-slide-toggle [checked]="hasExpiry" (change)="toggleExpiry()">
              </mat-slide-toggle>
            </div>

            <div class="form-field" *ngIf="hasExpiry" style="margin-left: 10px">
              <div style="width: 100%">
                <div class="form-field-label">
                  Expiry<span style="color: red">*</span
                  ><span
                    ><info-icon
                      text="The expiration period for the voucher, measured in days from the time the customer purchases it"
                    ></info-icon>
                  </span>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <input
                    class="form-input"
                    autocomplete="off"
                    placeholder="e.g. 14"
                    [formControl]="expiryDaysFormControl"
                    type="number"
                    [maxlength]="4"
                    min="0"
                    oninput="
                      javascript: if (this.value.length > this.maxLength)
                        this.value = this.value.slice(0, this.maxLength);
                    "
                    [ngStyle]="{
                      border:
                        expiryDaysFormControl.invalid && submitted
                          ? '1px solid red'
                          : '1px solid var(--app-light-grey)',
                    }"
                  />
                  <div
                    class="form-field-label"
                    style="width: 50px; padding-left: 10px"
                  >
                    days
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-field"
            style="margin-top: 20px"
            *ngIf="(valueFormControl.value ?? 0) > 0"
          >
            <div
              class="form-field"
              style="display: flex; justify-content: space-between"
            >
              <div class="form-field-label">
                Allow Partial Redemption
                <span>
                  <info-icon
                    text="If enabled, customers can redeem a portion of the voucher value and keep the remaining balance for later use"
                  ></info-icon>
                </span>
              </div>
              <mat-slide-toggle [formControl]="allowPartialRedemptionControl">
              </mat-slide-toggle>
            </div>
          </div>

          <div
            class="form-field"
            style="margin-top: 20px"
            *ngIf="voucherType === 'fixed'"
          >
            <div class="form-field-label">Quantity Limit</div>
            <input
              type="number"
              class="form-input"
              [formControl]="quantityLimitFormControl"
              placeholder="Leave blank for no limit"
            />
          </div>

          <div class="form-field" style="margin-top: 20px">
            <multiple-select
              label="Visibility"
              [infoText]="
                'Choose where this voucher will be available for purchase'
              "
              [formCtrl]="visibilityFormControl"
              [options]="visibilityOptions"
              [showAll]="false"
              value="label"
            >
            </multiple-select>
          </div>

          <div class="form-field" style="margin-top: 20px">
            <div class="form-field-label">Terms & Conditions<span> </span></div>

            <app-text-editor
              #termsEditor
              [html]="terms"
              (htmlChange)="terms = $event"
            ></app-text-editor>
          </div>
        </div>
      </div>

      <div class="form-field" style="margin-top: 20px"></div>
    </div>
    <div class="col-xl-5">
      <div class="detail-container" id="right">
        <div class="form-field">
          <div class="form-field-label" style="margin-bottom: 20px">
            Cover Image
            <span>
              <info-icon
                text="Shown on the voucher's detail page in the app and microsite. This image is not displayed in the PDF email"
              ></info-icon>
            </span>
          </div>
          <div class="cover-image-container">
            <file-upload
              (fileSelected)="selectedCover = $event"
              [readerResult]="initialCoverUrl ?? ''"
              [rounded]="true"
            ></file-upload>
            <button
              *ngIf="selectedCover || initialCoverUrl"
              mat-icon-button
              color="warn"
              class="delete-button"
              (click)="deleteCover()"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          <div class="cover-options" style="margin-top: 16px">
            <mat-radio-group [formControl]="coverOptionsFormControl">
              <div
                class="radio-option"
                [class.disabled]="!hasUploadedCover"
                (click)="
                  hasUploadedCover &&
                    coverOptionsFormControl.setValue('UPLOADED_ONLY')
                "
                style="cursor: pointer"
              >
                <mat-radio-button
                  value="UPLOADED_ONLY"
                  [disabled]="!hasUploadedCover"
                >
                  Restrict to uploaded image
                </mat-radio-button>
                <div class="radio-description">
                  {{
                    hasUploadedCover
                      ? "Customers can only use the cover image you upload"
                      : "Upload a cover image first to enable this option"
                  }}
                </div>
              </div>

              <div
                class="radio-option"
                (click)="
                  coverOptionsFormControl.setValue('UPLOADED_AND_LIBRARY')
                "
                style="cursor: pointer"
              >
                <mat-radio-button value="UPLOADED_AND_LIBRARY">
                  Allow library selection
                </mat-radio-button>
                <div class="radio-description">
                  Customers can use your image or
                  <a
                    href="#"
                    (click)="openLibrary($event)"
                    style="text-decoration: underline; color: blueviolet"
                    >choose from our design library</a
                  >
                  when gifting this voucher
                </div>
              </div>
            </mat-radio-group>
          </div>
        </div>

        <div class="form-field" style="margin-top: 30px">
          <div class="form-field-label" style="margin-bottom: 10px">
            PDF Email Artwork
          </div>
          <p
            class="help-text"
            style="margin-bottom: 15px; color: #666; font-size: 14px"
          >
            Override the default email artwork for this specific voucher's PDF.
            Recommended size: 1600x466px
          </p>
          <div class="cover-image-container">
            <file-upload
              [aspectRatio]="1600 / 466"
              [maintainAspectRatio]="true"
              (fileSelected)="onEmailArtworkSelected($event)"
              [maxFileSize]="2097152"
              [readerResult]="initialEmailArtworkUrl ?? ''"
            ></file-upload>
            <button
              *ngIf="selectedEmailArtwork || hasVoucherSpecificEmailArtwork"
              mat-icon-button
              color="warn"
              class="delete-button"
              (click)="deleteEmailArtwork()"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<loader [loading]="loading || saving || previewingPDF"></loader>

<mat-menu #actionsMenu="matMenu" class="custom-menu">
  <button
    class="menu-list-item"
    style="border-radius: 5px"
    (click)="previewPDF()"
    mat-menu-item
  >
    <mat-icon
      fontSet="material-icons-outlined"
      style="
        font-size: 16px;
        vertical-align: middle;
        display: flex;
        align-items: center;
        margin-right: 5px;
      "
      >picture_as_pdf</mat-icon
    >
    <span class="menu-list-item-label">Preview Voucher PDF</span>
  </button>
  <button
    class="menu-list-item"
    style="border-radius: 5px"
    (click)="sendTestEmail()"
    mat-menu-item
  >
    <mat-icon
      fontSet="material-icons-outlined"
      style="
        font-size: 16px;
        vertical-align: middle;
        display: flex;
        align-items: center;
        margin-right: 5px;
      "
      >email</mat-icon
    >
    <span class="menu-list-item-label">Send Test Email</span>
  </button>
</mat-menu>
